<div class="dark-mode">
    <div class="row mt-3">
        <div class="col-6 col-sm-6 col-md-6 text-end">
            <div class="d-flex" style="gap: 10px">
                <mat-form-field class="mb-1 w-100" appearance="outline" >
                    <mat-icon matPrefix>search</mat-icon>
                    <input type="text" placeholder="Search" matInput [(ngModel)]="pageQuery.search" (keyup)="searchUser($event); $event.stopPropagation()">
                    <mat-icon (click)="clearSearch()" *ngIf="showCloseSearch && pageQuery.search.length > 0" class="button-flat" matSuffix>close</mat-icon>
                </mat-form-field>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="table-responsive-dark list-wrapper-bordered-dark">
                <table class="table table-striped table-hover table-bordered ">
                    <thead>
                    <tr>
                        <th class="text-nowrap">Activity Type</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngIf="activities.length > 0">
                        <tr *ngFor="let activity of activities">
                            <td class="text-start">
                                {{activity.activityType}}
                            </td>

                        </tr>
                    </ng-container>

                    <tr *ngIf="activities.length == 0">
                        <td colspan="5" class="text-center">
                            <span>{{tableLoading ? 'Load data...' : 'No Record'}}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-2" *ngIf="activities.length > 0">
                <app-pagination-dark
                        (goPage)="toPage($event)"
                        (goPerPage)="perPageSet($event)"
                        [pagesToShow]="showPages"
                        [page]="pageNo"
                        [perPage]="pageSize"
                        [count]="totalRow"></app-pagination-dark>
            </div>
        </div>
    </div>
</div>

